import { useEffect, useRef } from 'react';
import { useAppSelector } from '../redux/hooks';

export function useAccountChange(enabled: boolean = false, ...callbacks: (() => void)[]) {
  const account_id = useAppSelector(state => state.appConfig.account_id);
  const prevAccountId = useRef<string | null>(null);

  useEffect(() => {
    if (account_id && enabled && account_id !== prevAccountId.current) {
      callbacks.forEach(callback => callback());
      prevAccountId.current = account_id;
    }
  }, [account_id, enabled]);
}

